import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCurrentUserPermissions } from '../../features/user/redux/userSelectors';
import { RootState } from '../../store';
import { ResourceType } from '../PricePrgClient';

const mapStateToProps = (state: RootState) => ({
    currentUserPermissions: getCurrentUserPermissions(state)
});

type OwnProps = {
    resource: ResourceType;
    link: string;
    childComponents: React.ReactElement;
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps;
const GuardedLink = ({ currentUserPermissions, resource, link, childComponents }: Props) => {
    if (!currentUserPermissions.isAdmin && !currentUserPermissions.accessiblePages.includes(resource)) {
        return null;
    }

    return (
        <Link to={link}>
            <>{childComponents}</>
        </Link>
    );
};

export default connect(mapStateToProps)(GuardedLink);
